import React, { useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import OneToOneChat from "./OneToOneChat";

const ChatWrapper = () => {
  const { id } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [currentUser, setCurrentUser] = useState(null);
  const [otherUser, setOtherUser] = useState(null);
  const [chatInitError, setChatInitError] = useState("");
  const eventIdFromContext =
    location.state?.eventId ||
    searchParams.get("eventId") ||
    searchParams.get("evt") ||
    null;
  const receiverId =
    location.state?.receiverId ||
    id ||
    searchParams.get("userId") ||
    searchParams.get("professionalId");

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const fullName = localStorage.getItem("fullName");
    const role = localStorage.getItem("role");
    const avatar = localStorage.getItem("profilePicture");
    const receiverData = location.state?.receiverData || {};

    if (!userId) {
      setChatInitError("Unable to start chat. Please login again.");
      return;
    }

    if (!receiverId) {
      setChatInitError("Unable to start chat for this professional.");
      return;
    }

    setChatInitError("");

    // ✅ FIXED
    setCurrentUser({
      _id: userId,
      uid: userId, // 🔥 IMPORTANT
      name: fullName,
      role,
      avatar,
    });

    setOtherUser({
      _id: receiverId,
      uid: receiverId, // 🔥 IMPORTANT
      name:
        receiverData?.fullName ||
        receiverData?.name ||
        location.state?.name ||
        receiverId,
      avatar:
        receiverData?.profilePicture ||
        receiverData?.avatar ||
        location.state?.avatar ||
        `https://ui-avatars.com/api/?name=${receiverId}`,
    });
  }, [receiverId, location.state]);

  if (chatInitError) {
    return (
      <div className="p-6 text-center text-sm text-red-500">
        {chatInitError}
      </div>
    );
  }

  if (!currentUser || !otherUser) return <div>Loading...</div>;

  return (
    // Layout fix: provide full viewport height so chat can keep input pinned at bottom.
    <div className="h-screen bg-white">
      <OneToOneChat
        currentUser={currentUser}
        otherUser={otherUser}
        eventId={eventIdFromContext}
      />
    </div>
  );
};

export default ChatWrapper;
